import React from 'react'
import "./WhatsHappening.css"

const WhatsHappening = () => {
    return (
        <>
            <div className='whatshead'>
                HERE'S WHATS HAPPENING
            </div>
            <div className='heroSection'>
                <img className='heroImg' src='https://rashki.com/cdn/shop/files/WhatsApp_Image_2024-09-25_at_5.32.27_PM_2200x.jpg?v=1727266414' />
                <button className='heroBtn'>SHOP NOW</button>

            </div>
        </>
    )
}

export default WhatsHappening